import clsx from 'clsx';
import { ICON_SIZES, type IconSize } from './SuperIcon.types';

export const resolveSize = (size: IconSize | number | undefined): number => {
  if (typeof size === 'number') return size;
  if (size && size in ICON_SIZES) return ICON_SIZES[size];
  return ICON_SIZES.md;
};

export const iconBaseClass = (className?: string): string =>
  clsx('inline-block shrink-0 align-middle', className);
